import { folded } from "../../lib/columnFilters";

// What the field Vervoerseisen offers while someone types in it: the requirements that are
// not chosen yet, found on their name or their code, accents and case left out of it
// ("koo" finds Kooiaap, "temp" all four temperatures). In the order Beheer keeps them.

export interface RequirementOption {
  id: string;
  code: string;
  name: string;
}

export function requirementOptions<T extends RequirementOption>(all: readonly T[], selected: readonly string[], text: string): T[] {
  const chosen = new Set(selected);
  const words = folded(text).split(/\s+/).filter(Boolean);
  return all.filter((option) => {
    if (chosen.has(option.id)) return false;
    const haystack = `${folded(option.name)} ${folded(option.code)}`;
    return words.every((word) => haystack.includes(word));
  });
}
